<template lang='pug'>
.container
  .container
    .row.mt-5.align-items-center
      .col-12.my-header.font-weight-bold FindGuest

  .container.mt-5 
    .row
      .col.white_block
        | Установите FindGuest Администратору заведения на телефон, что он, когда принимал звонки, видел имя гостя.
        br
        | FindGuest на iPhone:
        a(
          href="https://apps.apple.com/ru/app/findguest/id1470041896",
          target="_blank"
        ) https://apps.apple.com/ru/app/findguest/id1470041896
        br
        | FindGuest на Android:
        a(
          href="https://play.google.com/store/apps/details?id=com.codebase.findguest",
          target="_blank"
        ) https://play.google.com/store/apps/details?id=com.codebase.findguest
  .container.mt-2
    .row
      .col.white_block QR-код для входа в приложение:
        qrcode(:value="secret_code")
        | {{ secret_code }}
      .col.white_block Ваша база гостей: {{ clients_count }} (обновляется ежедневно)
</template>
<script>
var apiDriver = require("../../apiDriver").default;

export default {
  data() {
    return {
      secret_code: "...",
      clients_count: "...",
    };
  },

  computed: {},

  mounted() {
    this.getSecretCode();
    this.getClientsCount();
  },

  methods: {
    async getSecretCode() {
      let x = (await apiDriver.services.api.get("findguest", "secretcode"))
        .data;
      this.secret_code = x.secret_code;
    },
    async getClientsCount() {
      let x = (await apiDriver.services.api.get("findguest", "my_clients"))
        .data;
      this.clients_count = x.clients_count;
    },
  },
};
</script>
<style scoped lang="stylus">
.white_block {
  background: white;
  margin: 5px;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 7px;
}

.my-header {
  font-size: 26pt;
}

.header-sub {
  font-size: 1.5rem;
}
</style>
